<template>
    <div id="data-view">
        <dv-full-screen-container>
            <header-top/>
            <left-main/>
            <right-main/>
            <div class="map">
                <Map ref="map"></Map>
            </div>
        </dv-full-screen-container>
        <div class="clear_both"></div>
    </div>

</template>

<script>
    import HeaderTop from "./Header";
    import LeftMain from "./LeftMain";
    import RightMain from "./RightMain";
    import Map from "./map/map"

    /* import LeftChart1 from "./LeftChart1";
    import LeftChart2 from "./LeftChart2";
    import LeftChart3 from "./LeftChart3";
    import CenterCmp from "./CenterCmp";
    import RightChart1 from "./RightChart1";
    import RightChart2 from "./RightChart2";
    import BottomCharts from "./BottomCharts"; */

    export default {
        name: "DataView",
        components: {
            HeaderTop,
            LeftMain,
            RightMain,
            Map,
            /* LeftChart1,
            LeftChart2,
            LeftChart3,
            CenterCmp,
            RightChart1,
            RightChart2,
            BottomCharts, */
        },
        data() {
            return {};
        }
    };
</script>

<style lang="less">
  #data-view {
    width: 100%;
    height: 100%;
    background-color: #5E767E;
    color: #fff;

    .clear_both {
      content: "";
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    #dv-full-screen-container {
      //background-color: #5E767E;
      // background-size: 100% 100%;
      // box-shadow: 0 0 3px blue;
      display: flex;
      flex-direction: column;
    }

    .map {
      //position: absolute;
      //left: 320px;
      //top: 10px;
      //right: 480px;
      //bottom: 160px;
      //z-index: 990;
      width: -webkit-fill-available;
    }

    /*  .main-header {
       height: 80px;
       display: flex;
       justify-content: space-between;
       align-items: flex-end;

       .mh-left {
         font-size: 20px;
         color: rgb(1, 134, 187);

         a:visited {
           color: rgb(1, 134, 187);
         }
       }

       .mh-middle {
         font-size: 30px;
       }

       .mh-left,
       .mh-right {
         width: 450px;
       }
     }

     .main-container {
       height: calc(~"100% - 80px");

       .border-box-content {
         padding: 20px;
         box-sizing: border-box;
         display: flex;
       }
     }

     .left-chart-container {
       width: 22%;
       padding: 10px;
       box-sizing: border-box;

       .border-box-content {
         flex-direction: column;
       }
     }

     .right-main-container {
       width: 78%;
       padding-left: 5px;
       box-sizing: border-box;
     }

     .rmc-top-container {
       height: 65%;
       display: flex;
     }

     .rmctc-left-container {
       width: 65%;
     }

     .rmctc-right-container {
       width: 35%;
     }

     .rmc-bottom-container {
       height: 35%;
     }

     .rmctc-chart-1,
     .rmctc-chart-2 {
       height: 50%;
     } */
  }
</style>
